// extracted by mini-css-extract-plugin
export var link = "_g-0";